import React, { Component } from "react";

export default class AnimatedCounter extends Component {
  constructor(props) {
    super(props);
    this.state = { display: props.value || 0 };
    this.frame = null;
  }

  componentDidMount() {
    this.animateTo(this.props.value || 0, this.state.display);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.animateTo(this.props.value || 0, this.state.display);
    }
  }

  componentWillUnmount() {
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  animateTo = (target, from) => {
    const start = performance.now();
    const duration = this.props.duration || 700;
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const value = from + (target - from) * ease(t);
      this.setState({ display: value });
      if (t < 1) this.frame = requestAnimationFrame(step);
    };
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(step);
  };

  render() {
    const { format, decimals = 0 } = this.props;
    const v = this.state.display;
    const text = format
      ? format(v)
      : v.toLocaleString("fr-FR", {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        });
    return <span>{text}</span>;
  }
}
